import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import QueryTags from "api/types/QueryTags";
import { UpdatePracticeFeaturesRequest } from "api/types/requests";
import PracticeFeaturesResponse from "api/types/models/practice_features";

const practiceFeatureEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getPracticeFeatures: builder.query<PracticeFeaturesResponse, void>({
    query: () => ({
      url: "/practice_features",
    }),
    providesTags: ["PracticeFeatures"],
  }),

  updatePracticeFeatures: builder.mutation<void, UpdatePracticeFeaturesRequest>(
    {
      query: (body) => ({
        url: "/practice_features",
        method: "put",
        body,
      }),
      invalidatesTags: ["PracticeFeatures"],
    },
  ),
});

export default practiceFeatureEndpoints;
